module['exports'] = [
  '#{prefix} #{first_name} #{last_name}',
  '#{first_name} #{last_name} #{suffix}',
  '#{first_name} #{last_name}',
  '#{first_name} #{last_name}',
  '#{male_first_name} #{last_name}',
  '#{female_first_name} #{last_name}',
  '#{male_first_name} بن #{male_first_name}',
  '#{female_first_name} بنت #{male_first_name}',
];
